import React from "react";
import { Trans } from "@lingui/macro";
import { TransProps } from "@lingui/react";

export type typeDateFilterForCommonFilters = {
  toValue: string;
  minData?: string; // 'yyyy-mm-dd'
  maxData?: string; // 'yyyy-mm-dd'
  fromValue: string;
  setToValue: React.Dispatch<any>;
  setFromValue: React.Dispatch<any>;
  label: React.ReactElement<TransProps>;
};

const DateFilter: React.FC<typeDateFilterForCommonFilters> = ({
  label,
  toValue,
  fromValue,
  setToValue,
  setFromValue,
  minData = "2000-01-01",
}) => {
  const [errorToData, setErrorToData] = React.useState(false);
  const [errorFromData, setErrorFromData] = React.useState(false);

  const today = new Date();
  const formattedToday = `${today.getUTCFullYear()}-${
    today.getUTCMonth() + 1 > 9
      ? today.getUTCMonth() + 1
      : "0" + (today.getUTCMonth() + 1)
  }-${today.getUTCDate() > 9 ? today.getUTCDate() : "0" + today.getUTCDate()}`;

  React.useEffect(() => {
    if (fromValue === formattedToday && toValue !== formattedToday) {
      setToValue(formattedToday);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromValue]);

  React.useEffect(() => {
    if (
      Date.parse(fromValue) >= Date.parse(formattedToday) &&
      Date.parse(fromValue) <= Date.parse(minData)
    ) {
      setErrorFromData(true);
    } else {
      setErrorFromData(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromValue]);

  React.useEffect(() => {
    if (
      Date.parse(fromValue) >= Date.parse(formattedToday) &&
      Date.parse(fromValue) <= Date.parse(minData)
    ) {
      setErrorToData(true);
    } else {
      setErrorToData(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromValue]);

  const onFromChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) setFromValue("");

    if (Date.parse(e.target.value)) {
      setFromValue(e.target.value);
    }
  };

  const onToChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) setToValue("");

    if (Date.parse(e.target.value)) {
      setToValue(e.target.value);
    }
  };

  return (
    <div>
      <p className="mb-1 text-sm font-medium text-gray-700">{label}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 border border-gray-300 rounded-md p-2">
        <label htmlFor="fromDate" className="text-sm font-medium text-gray-500">
          <p>
            <Trans>From: </Trans>
          </p>
          <input
            type="date"
            min={minData}
            minLength={8}
            id="fromDate"
            value={fromValue}
            onChange={onFromChange}
            max={toValue || formattedToday}
            className={`p-2 sm:px-3 sm:py-2 w-full sm:w-auto border ${
              errorFromData
                ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                : "border-gray-300 focus:ring-primary-500 focus:border-primary-500"
            } rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm`}
          />
          {errorFromData && (
            <p className="text-xs mt-1 text-red-500">
              <Trans>Invalid date</Trans>
            </p>
          )}
        </label>
        <label
          htmlFor={"toDate"}
          className="text-sm font-medium text-gray-500 "
        >
          <p>
            <Trans>To: </Trans>
          </p>
          <input
            type="date"
            id="toDate"
            max={formattedToday}
            minLength={8}
            value={toValue}
            onChange={onToChange}
            min={fromValue || minData}
            className={`p-2 sm:px-3 sm:py-2 w-full sm:w-auto border ${
              errorToData
                ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                : "border-gray-300 focus:ring-primary-500 focus:border-primary-500"
            } rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm`}
          />
          {errorToData && (
            <p className="text-xs mt-1 text-red-500">
              <Trans>Invalid date</Trans>
            </p>
          )}
        </label>
      </div>
    </div>
  );
};

export default DateFilter;
